import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import "../../Styles/form.css";

const Form = () => {
  const location = useLocation();
  const isCareersPage = location.pathname === "/careers";

  const [formData, setFormData] = useState({
    u_name: "",
    email: "",
    mobile: "",
    looking_for: "",
    nmessage: "",
  });

  const [resumeFile, setResumeFile] = useState(null);
  const [message, setMessage] = useState({ text: "", type: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ text: "Submitting...", type: "info" });

    try {
      // Build FormData payload
      const formPayload = new FormData();
      formPayload.append("u_name", formData.u_name);
      formPayload.append("email", formData.email);
      formPayload.append("mobile", formData.mobile);
      formPayload.append("looking_for", formData.looking_for);
      formPayload.append("nmessage", formData.nmessage);

      if (resumeFile) {
        formPayload.append("resume", resumeFile);
      }

      // POST request
      const emailResponse = await fetch(
        "/ann/ann-ai-cms/public/api/contactus",
        {
          method: "POST",
          body: formPayload, // don't set Content-Type manually
        }
      );
      if (emailResponse.ok) {
        setMessage({
          text: "✅ Form submitted & email sent successfully!",
          type: "success",
        });
        setFormData({
          u_name: "",
          email: "",
          mobile: "",
          looking_for: "",
          nmessage: "",
        });
        setResumeFile(null);
      } else {
        const errorText = await emailResponse.text();
        setMessage({
          text: `⚠️ Something went wrong: ${errorText}`,
          type: "error",
        });
      }
    } catch (error) {
      console.error("Error:", error);
      setMessage({
        text: "❌ Failed to submit. Please check your connection.",
        type: "error",
      });
    }
  };
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <div className="form-card">
      <form className="contact-form" onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label>Full Name *</label>
            <input
              type="text"
              name="u_name"
              value={formData.u_name}
              onChange={handleChange}
              placeholder="Enter your name"
              required
            />
          </div>
          <div className="form-group">
            <label>Email *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email"
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Phone</label>
            <input
              type="text"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              placeholder="Enter your phone"
            />
          </div>
          <div className="form-group">
            <label>Subject *</label>
            <input
              type="text"
              name="looking_for"
              value={formData.looking_for}
              onChange={handleChange}
              placeholder="Enter subject"
              required
            />
          </div>
        </div>

        <div className="form-group full-width">
          <label>Message *</label>
          <textarea
            name="nmessage"
            rows="4"
            value={formData.nmessage}
            onChange={handleChange}
            placeholder="Write your message"
            required
          />
        </div>

        {isCareersPage && (
          <div className="form-group full-width">
            <label>Upload Resume</label>
            <input
              type="file"
              className="upload-resume"
              onChange={(e) => setResumeFile(e.target.files[0])}
            />
          </div>
        )}

        <button className="submit-btn" type="submit">
          Submit →
        </button>

        {message.text && (
          <p
            style={{
              marginTop: "1rem",
              color:
                message.type === "success"
                  ? "green"
                  : message.type === "error"
                    ? "red"
                    : "black",
            }}
          >
            {message.text}
          </p>
        )}
      </form>
    </div>
  );
};

export default Form;
